<template> 
    <div style="background:#fff; margin-top:0px;margin-left:3px; "> 
        <div v-if="toolFlag" style="border-bottom:2px solid #389;border-left:3px solid #409eff;min-width:1100px; ">
            <span style="margin-left:5px;">字段查询</span>
            <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:130px;margin-left:5px; ">
                <span v-for="item in tabCol" :key='item.key'>
                    <el-option v-if="item.fhide==='N'" :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            <el-select v-model="oper"  size="small" style="width:110px;margin-bottom:3px;margin-left:2px; ">
                <span v-for="item in operArr" :key='item.IDSEQ'>
                    <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                </span>
            </el-select>
            <el-input placeholder="请输入查询值" @keyup.enter.native="qryTabData" v-model="textparam" size="small" style="width:210px;margin-left:2px;margin-top:3px; ">
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
            </el-input>
  
            <el-button type="danger" size="mini" icon="iconfont icon-chenggong1" @click="selSure" style=" margin-top:0px; margin-left:15px;">确定选择</el-button>   
        </div>
        <el-table :data="dtlData" 
            border                            
            disabled-hover
            header-cell-class-name="clearPadding"
            :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
            class="custom-table-border"  
            style="overflow:auto;margin-top:3px;"
            v-loading="loading"
            element-loading-background = "rgba(255, 255, 255, .5)"
            element-loading-text = "加载中，请稍后..."
            element-loading-spinner = "el-icon-loading"
            size="small"
            ref="frmtab"
            :height="tabHeight" 
            @select="selChk"
            @select-all="selAll"
            :row-key="getRowKey"
            highlight-current-row>
            <el-table-column type="selection" width="50" fixed align="center"> </el-table-column>
            <el-table-column label="序号" type="index" width="60" fixed align="center">
                <el-table-column label="序号" type="index" width="60" fixed align="center">
                    <template slot="header"  >
                        <el-link   @click="rowShow" style="font-size:12px;color:#404eff"> 
                            <el-tooltip content=" 清除条件" effect="light">
                                <i class="iconfont icon-shanchu1"  ></i>
                            </el-tooltip>
                        </el-link>
                    </template>
                </el-table-column>
            </el-table-column> 
            <el-table-column v-for="(item ,index) in tabCol.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"  
                :fixed="item.key==='RN'"                                
                sortable
                :min-width="item.width">
                <el-table-column  resizable :prop="item.key" :label="item.title" :align="item.align"  show-overflow-tooltip :min-width="item.width">
                    <template slot="header" slot-scope="scope">
                        {{scope.row}}
                        <el-input :disabled="item.edcss=='image'"   @keyup.enter.native="qryTabData"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                    </template>
                    <template slot-scope="scope">
                       
                        <span  v-text="scope.row[item.key]" ></span>
                    </template>
                </el-table-column> 
            </el-table-column> 
 
            <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="120">
                <template slot-scope="scope">
                    <i class="iconfont icon-chakan-copy" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                    <el-link   @click="qryLog(scope.row )" :underline="false"  ><span style="font-size:11px;margin-right:15px;">查看日志 </span></el-link>
                </template>
            </el-table-column>              
        </el-table>
        <el-table :data="selArr" 
                border                            
                disabled-hover
                style="overflow:auto;margin-top:3px;"
                size="small"
                ref="frmtab"
                :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                class="custom-table-border" 
                :height="350" 
                :row-key="getSubKey"   
                highlight-current-row>
 
                <el-table-column  v-for="(item ,index) in tabCol.filter(item=>item.thide=='N')" :key="index"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"  
                    :fixed="item.key==='RN'"                                
                    sortable
                    :min-width="item.width">
                </el-table-column> 
 
        </el-table>
        <!-- 提示 -->
        <el-dialog :show-close="false" v-dialogDrag :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">确定</Button>
            </div>
        </el-dialog>
        <!--  日志明细 -->
        <el-dialog class="pub_dialog"  :visible.sync="logWin" width="1200px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">日志明细</span>
            </div>            
            <el-table :data="logData" 
                    border                            
                    disabled-hover
                    style="overflow:auto;margin-top:3px;"
                    size="small"
                    :height="logHeight" 
                    highlight-current-row>
                <span  v-for="(item ,index) in logCol" :key="index">   
                    <el-table-column   v-if="item.fhide==='N' &&item.key!=='FLAG'"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"  
                        :fixed="item.key==='RN'"                                
                        sortable
                        :min-width="item.width">
                    </el-table-column> 
                    <el-table-column  v-if="item.key==='FLAG'"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :min-width="item.width">
                        <template   slot-scope="scope" >
                            <i v-if="scope.row.FLAG==='Y'" class="iconfont icon-xuanze" style="color:green"></i>
                            <i v-if="scope.row.FLAG==='N'" class="iconfont icon-xuanze" style="color:red"></i>
                        </template>
                    </el-table-column>  
                </span>          
            </el-table>
            <div slot="footer" style="color:#F56C6C;font-weight:600;font-size:12px;">
                提示：标记为红色：表示单据引起库存减少，绿色：表示单据数量引起库存增加
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getTabColOrData,getBaseData } from '../../api/user' 
import {getDate} from '../../api/Select' 
export default {
    props: {
        toolFlag:{
            type:Boolean,
            default:true
        },
        v_stkno:{
            type:String,
        }
    },
    data () {
        return {
            logWin:false,
            operArr:[],
            v_row:{},
 
            prompt:'', // 
            promptWin:false,
            input_hold:'请输入内容... 按回车键以查询',
            selparam:'STKNM',// select 绑定值
            oper:'like',
            textparam:'', // input 绑定值
            tabCol:[] ,//表列集合
            logCol:[],
            logData:[] ,// 
            dtlData:[],
            dataCount:0,
            rowSize:20,
            goPage:'',
            current:1,
            baseData:[] ,//表数据
            
            selArr:[] , 
            editrmk:'',//  
            rowLstseq:'' ,//
            disabled:false,
            defaultProps: {  //el-tree 默认字段属性
                children: 'children',
                id:'id',
                icon:'icon',
                parentid:'',
                label: 'label'
            },
            v_url:'xuper_auth/getTableRecMany' , //api请求路径      
            v_formurl:'xuper_auth/getTableRecMany', //多记录查询 like模式       
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//corp id
            loading:false,// table加载bool
            type:'create',
            pageList: [ {
                value: 20,
                label: '20'
                }, {
                value: 30,
                label: '30'
                }, {
                value: 40,
                label: '40'
            }],
            stfgBool:true,
            formCol:{}, //表格单行记录 model
 
            notNull:[],
            treeid:'0',
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止 
            v_admin:this.$cookies.get('v_admin') ,//  
        }
    },
    created () {
        this.getTabCol() //得到 表列数组 
        this.getFormData()
    },
    components: {
 
    },
    watch: {
        v_stkno:function(){ //侦测变量值改变时 执行此方法
            this.getFormData()  
            this.selArr=[]
        }   
    },
    mounted () {   
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
    } ,
    computed: {
        tabHeight() {
          return  window.innerHeight -490
        },
        logHeight() {
          return  window.innerHeight -160
        },
 
    },
    methods: { 
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.qryTabData()
        } ,
        selChk(selection,row) {
            this.selArr =selection
        },
        selAll(selection){
            this.selArr =selection
        },
        selSure(){
            this.$emit('child-sure',this.selArr)
        },
        qryLog(row){
            this.logWin =true
            this.getLogData(row.STKNO,row.MATNO) 
        },
 
        getRowKey(row){
            return row.PKSEQ
        },
        getSubKey(row){
            return row.IDSEQ
        },
        //查询表格数据
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.textparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.textparam+'\''
                }
            }
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_edcss =='number'){
                        v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                    }else{
                        v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                    }

                }
            })
            this.getFormData(cond_ +v_cond )
        },
 
        //获取表单数据
        getFormData(cond){
            var vm=this
            this.loading =true
            getTabColOrData(this.v_formurl,'v_IC_STKLOG','corpid',this.v_corpid,'stkno',this.v_stkno,'','',cond).then((res) => {              
                if (res.code==='200'){
                    this.dtlData=res.result   
    
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                vm.loading =false         
            });            
        },
        //日志记录
        getLogData(stkno,matno){
            getTabColOrData(this.v_formurl,'v_IC_STKDTL','corpid',this.v_corpid,'stkno',stkno,'matno',matno ,' and stfg=\'Y\' order by icdttm').then((res) => {              
                this.logData=[]
                if (res.code==='200'){
                    this.logData=res.result   
                }
            })           
        },
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','116','LSTSEQ','1' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        thide: res.result[k].THIDE,
                        fhide: res.result[k].FHIDE,
                        disabled: res.result[k].DISABLED,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','116','LSTSEQ','2' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.logCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        thide: res.result[k].THIDE,
                        fhide: res.result[k].FHIDE,
                        disabled: res.result[k].DISABLED,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                    })
                }
            })
        },
    }
}
 
</script>
<style scoped lang="less" >
    .selinput{
        width:340px;
        margin-left:10px; 
    }
    .colwidth{
        width:140px;
    }
    .colwidth2{
        width:642px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    } 
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
</style>
<style lang="less">
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #f3b6b6 !important;
      color:rgb(30, 44, 90);
    }
    .el-tree-node__content:hover {    
      background-color: #66b1ff87;
    }
    .tree-scroll{
        width :180px;
        border: 1px solid #f5dbdb;
        height: 100%;
    }
   .el-table {
    th {
        padding: 0 ;
    }
    thead{
        height: 15px !important;
        color:rgb(128,128, 128);
        font-size:12px;
    }
    td {
        padding: 5px ;
        font-size:11px;
    }   
  }
  .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
